<template>
  <LayoutDefault :title="vns.name">
    <Monitor/>
  </LayoutDefault>
</template>

<script>
import LayoutDefault from "@/templates/LayoutDefault";
import {mapActions, mapGetters} from "vuex";
import Monitor from "@/pages/vns/components/Monitor";

export default {
  name: "Show",
  components: {Monitor, LayoutDefault},
  computed: {
    ...mapGetters({
      vns: 'vns/current',
      isLoading: 'vns/isLoading'
    })
  },
  methods: {
    ...mapActions([
      'vns/listOne'
    ])
  },
  async mounted() {
    this.$store.commit('vns/setCurrent', {})
    await this['vns/listOne'](this.$route.params.id);
  }
}
</script>

<style lang="scss" scoped>
</style>
